import { Slide } from "@jelly/lesson";

const principle: Slide = {
  title: "Introduction",
  layout: {
    type: "customCase010101",
    options: {
      content: `The primary objective of this case study is to show how fundamental acoustics basic notions can be used for the characterization of a two-port device.<br /><br />
      We begin by explaining the concept of a multi-port device and the methodologies employed for its characterization. Subsequently, we introduce the notion of an equivalent fluid and provide a detailed account of an impedance head, which aims at measuring simultaneously pressure and volume velocity.<br /><br />
      In conclusion, we present a comprehensive, step-by-step overview of two commonly employed methods for performing this characterization. The first approach involves utilizing four microphones, while the second approach centers around the use of a commercial impedance head.<br /><br />
      By presenting these methods, we aim to offer valuable insights into the effective characterization of two-port devices.
      `,
    },
  },
};

export default principle;
